import axios from "axios";
import ApolloFilters from "./ApolloFilters.js";

var CabinetResource = {
    initializeHeaders: function (headers) {
        axios.defaults.headers.common = headers;
    },
    get: function (params) {
        return axios.get(
            Apollo.resolveApiUrl('~/cabinetmedication'),
            {
                params: params
            });
    },
    post: function (medication) {
        return axios.post(
            Apollo.resolveApiUrl('~/cabinetmedication'),
            medication
        );
    },
    put: function (medication) {
        return axios.put(
            Apollo.resolveApiUrl('~/cabinetmedication/') + medication.Id,
            medication
        );
    },
    delete: function (medication) {
        return axios.delete(
            Apollo.resolveApiUrl('~/cabinetmedication/') + medication.Id
        );
    },
    getInteractions: function (ndc) {
        return axios.get(
            Apollo.resolveApiUrl('~/CabinetMedication/getInteractions?ndc=' + ndc) 
        );
    }
};

export default CabinetResource;



// WEBPACK FOOTER //
// ./src/models/CabinetResource.js